














import { Component, Vue } from 'vue-property-decorator';
import LoginBox from '@/auth/LoginBox.vue';

@Component(
{
    components: { LoginBox }
})
export default class Login extends Vue
{
}
